export default "__VITE_ASSET__C8zx55GO__"